/* @flow */
import ConfirmDialog from 'components/ConfirmDialog';
import Group from 'entities/Group';
import GroupActions from 'groups/actions/GroupActions';
import * as React from 'react';
import ToastActions from 'actions/ToastActions';

type Props = {
  group: Group,
  checkedIds: Backbone$Id[],
  userName?: string,
  onFinish?: () => void,
  onRequestHide?: () => void,
};

class AddGroupOwnerModalConfirm extends React.Component<Props> {
  addOwners = () => {
    const successMessage =
      'Class ' + (this.props.checkedIds.length > 1 ? 'owners' : 'owner') + ' added';

    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }

    GroupActions.promoteGroupMemberships(this.props.group, this.props.checkedIds).then(
      () => {
        ToastActions.showSuccessToast(successMessage);
        if (this.props.onFinish) {
          this.props.onFinish();
        }
      },
      e => {
        const errorMessage =
          e.message || `An error occured removing user from ${this.props.group.getName()}.`;
        ToastActions.showErrorToast(errorMessage);
      }
    );
  };

  render() {
    const ownersCount = this.props.checkedIds.length;
    let confirmTitle;
    if (ownersCount > 1) {
      confirmTitle = `Are you sure you want to add ${ownersCount} class owners?`;
    } else if (this.props.userName) {
      confirmTitle = `Are you sure you want to add ${this.props.userName} as class owner?`;
    } else {
      confirmTitle = 'Are you sure you want to add a class owner?';
    }

    return (
      <ConfirmDialog
        eventScreenName="AddGroupOwnerModalConfirm"
        {...this.props}
        title={confirmTitle}
        subtext={'All class owners have the same controls. Once added, an owner can’t be removed.'}
        actionButtonText="Add"
        cancelButtonText="Cancel"
        onConfirm={this.addOwners}
      />
    );
  }
}
export default AddGroupOwnerModalConfirm;
